<script>
import formatDate from '@utils/format-date'
import lazyLoadComponent from '@router/lazyload-component'

import cloneDeep from 'lodash/cloneDeep'
const initData =  {
  images: [],
  content: '',
  uuid: '',
  type: '',
  questions: {
    afterOrderOption: [null, null, null, null, []],
    afterOrder: [],
    handle: [],
  },
  petId: '',
  memberId: '',
  orderNo: '',
}
const defaultComment = {
  id: '',
  content: '',
}
export default {
  components: {
    PetCommentList: () => lazyLoadComponent(import('@components/PetCommentList')),
    MemberInfoCommentList: () => lazyLoadComponent(import('@components/MemberInfoCommentList')),
    PetInfoCommentList: () => lazyLoadComponent(import('@components/PetInfoCommentList')),
  },
  filters: {
    formatDate,
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: 'member_private',
      validator(value) {
        return [
          'service',
          'pet',
          'member_private',
        ].includes(value)
      },
    },
    isCanAdd: {
      type: Boolean,
      default: false
    },
    isOrder: {
      type: Boolean,
      default: false
    },
    isEditStatus: {
      type: Boolean,
      default: false
    },
    singleValue: {
      type: Object,
      default: () => {}
    },
        // 判斷是否只是美容師
    isEmployee: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEdit: false,
      tryingSave: false,
      tryingList: false,
      submitData:cloneDeep(initData),
      commentData:cloneDeep(defaultComment),
      isUpdate: false,
    }
  },
  computed: {

  },
  watch: {
    // defaultValue: {
    //   handler(val) {
    //     this.submitData = cloneDeep({
    //       ...val,
    //       phone: val.phoneNumber,
    //       merchantNote: val.merchantNote.replace(/<br\s\/>/g, ''),
    //       extraInfos: val.extraInfos 
    //       ?? {
    //         extraInfoPhone: [extraInfoPhone],
    //         extraInfoEmergency: [extraInfoEmergency]
    //       }
    //     })
    //   },
    //   immediate: true,
    // },
    singleValue: {
      handler(val) {
        if (this.isOrder) {
          this.submitData = cloneDeep(val)
        }
      },
      immediate: true,
    },
  },
  created() {
    
  },
  mounted() {

  },
  methods: {
    updateValue() {
      this.$emit('update', this.type)
    },
    editCommemt(item = {}) {
      this.isEdit = true
      this.submitData = { ...item }
      if(this.type === 'pet' && this.isOrder) {
        this.$emit('edit',true)
        this.$emit('item',item)
      }
      this.commentData = cloneDeep(defaultComment)
    },
    closeEditComment() {
      this.isEdit = false
      this.isUpdate = false
      if(this.type === 'pet' && this.isOrder) {
        this.$emit('edit',false)
      }
      this.commentData = cloneDeep(defaultComment)
    },
    async tryToStoreMemberInfoCommemt() {
      if(this.isUpdate) {
        const {id, content, memberId, type} = this.commentData
        await this.$store.dispatch('comment/store', {
          type,
          content,
          memberId,
          uuid: id,
        }).then(() => {
          this.updateValue()
          this.isUpdate = false
          this.isEdit = false
        })
      } else {
        // 新增
        const { id } = this.defaultValue
        await this.$store.dispatch('comment/store', {
          type: 'member_private',
          memberId: id,
          content: this.commentData.content
        }).then(() => {
          this.updateValue()
          this.isEdit = false
        })
      }
    },
    editUpdateCommemt(item) {
      this.isEdit = true
      this.isUpdate = true
      this.commentData = {...item}
      if(this.type === 'pet' && this.isOrder) {
        this.$emit('edit', true)
        this.$emit('item',this.commentData)
      }
    },
    async tryToStorePetInfoCommemt() {
      if(this.isOrder && this.submitData?.id) {
        const {id, content, petId, type} = this.submitData 
        await this.$store.dispatch('comment/store', {
          type,
          content,
          petId,
          uuid: id,
        }).then(() => {
          this.updateValue()
          this.isUpdate = false
          this.editPetDetailEnabled = false
          this.$emit('item',this.submitData)
        })
      } else {
        if(this.isUpdate) {
          const {id, content, petId, type} = this.isOrder ? this.submitData : this.commentData
          await this.$store.dispatch('comment/store', {
            type,
            content,
            petId,
            uuid: id,
          }).then(() => {
            this.updateValue()
            this.isUpdate = false
            this.editPetDetailEnabled = false
            this.$emit('item',this.commentData)
          })
        }else {
          const { id } = this.defaultValue
          await this.$store.dispatch('comment/store', {
            type: 'pet',
            petId: id,
            content: this.commentData.content
          }).then(() => {
            this.updateValue()
            this.editPetDetailEnabled = false
          })
          this.$emit('item',this.commentData)
        }
      }

      this.$emit('edit', false)
      this.$emit('update')  
    },
    async onClickRemove(id) {
      // this.tryingList = true
      try {
        await this.$store.dispatch('comment/removeComment', { ids: [id] })
        this.$message({ message:'刪除成功', type: 'success' })
        this.updateValue()
      } finally {
        // this.tryingList = false
      }
    },
  },
}
</script>

<template>
  <div :class="$style.Note">
    <template v-if="type === 'member_private'">
      <el-button 
        v-if="!isEdit && isOrder && isCanAdd"
        type="primary"
        class="w-100 is-round mb-5"
        @click="editCommemt({})"
      >
        <BaseIcon name="plus"/> 新增備註
      </el-button>
      <MemberInfoCommentList
        v-if="!isEdit"
        v-loading="tryingList" 
        :default-value="defaultValue.memberPrivateComments.items"
        :is-order="isOrder"
        :is-employee="isEmployee"
        @edit="editUpdateCommemt"
        @remove="onClickRemove"
      />
      <template v-if="isCanAdd">
        <template v-if="!isEdit && isOrder"></template>
        <template  v-else>
          <p class="fs-lg mb-3 fw-medium text-text">
            新增備註 
            <span class="fs-2sm text-text-light fw-regular">(客戶無法查看)</span>
          </p>
          <el-input 
            v-model="commentData.content" 
            type="textarea" 
            class="mb-5 bg-white is-border is-round"
            :autosize="{ minRows: 5 }"
          />
          <div class="btn-group-inline">
            <el-button class="is-round" @click="closeEditComment">取消</el-button>
            <el-button :loading="tryingSave" :disabled="tryingSave" class="is-round" type="primary" @click="tryToStoreMemberInfoCommemt">儲存</el-button>
          </div>
        </template>
      </template>
    </template>
    <template v-if="type === 'pet'">
      <template v-if="!isEdit && !isEditStatus">
        <h4 class="form-block-title">
          {{ $t('member.PET_TO_SKIN')}}備註
          <el-button type="text" size="mini" @click="editCommemt">
            <BaseIcon name="edit" class="text-primary fs-xl align-text-top"/>
            <span>新增備註</span>
          </el-button>
        </h4>
        
        <PetInfoCommentList 
          v-if="defaultValue.petComments" 
          :default-value="defaultValue.petComments.items"
          :is-order="isOrder"
          @edit="editUpdateCommemt"
          @remove="onClickRemove"
        />
      </template>
      <template v-else>
        <template v-if="isCanAdd">
          <p class="fs-base mb-3 fw-medium text-text">
            {{ $t('member.PET_TO_SKIN')}}備註 
          </p>
          <el-input
            v-if="!submitData.id"
            v-model="commentData.content" 
            type="textarea" 
            class="mb-5 bg-white is-border is-round"
            :autosize="{ minRows: 5 }"
          />
          <el-input
            v-else
            v-model="submitData.content" 
            type="textarea" 
            class="mb-5 bg-white is-border is-round"
            :autosize="{ minRows: 5 }"
          />
          
          <div class="btn-group-inline mt-5">
            <el-button class="is-round" @click="closeEditComment">取消</el-button>
            <el-button :loading="tryingSave" :disabled="tryingSave" class="is-round" type="primary" @click="tryToStorePetInfoCommemt">儲存</el-button>
          </div>
        </template>
      </template>
    </template>
    <template v-if="type === 'service'">
      <PetCommentList v-if="defaultValue.id" ref="commentAll" :order="undefined" :pet="defaultValue.id" type="pet" />
    </template>
  </div>
</template>

<style lang="scss" module>
.Note {
  :global {

  }
}
</style>
